import * as React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { appStore } from './redux-state';
import App from './components/app';
//if (process.env.NODE_ENV !== 'production') {
//    const { whyDidYouUpdate } = require('why-did-you-update');
//    whyDidYouUpdate(React);
//}

declare const document;

render(
    <Provider store={appStore}>
        <App />
    </Provider>
    , document.getElementById("calendar-entry-js"));